module.exports = __webpack_public_path__ + "img/Jigsaw.e5b9f86c.png";